var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('styled-circle-button',{staticClass:"modal-close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('icon',{attrs:{"name":"times"}})],1),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }